export const parseNumberMoney = (valueParam) => {
    let value = valueParam;
    if (typeof valueParam === 'string') {
        value = parseFloat(valueParam);
    }
    if (!value) {
        return `$0.00`;
    }
    try {
        const formattedValue = value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2
        });
        return formattedValue;
    }
    catch (error) {
        console.log(error);
        return `${value}`;
    }
};
export const getSubscriptionDaysRemaining = (trialEnd) => {
    const currentDate = Math.floor(Date.now() / 1000); // Get current date in seconds
    const secondsRemaining = trialEnd - currentDate;
    const daysRemaining = Math.ceil(secondsRemaining / 86400);
    return daysRemaining;
};
export const parsePercent = (num) => {
    try {
        if (num === 100)
            return num.toFixed(1);
        return num.toFixed(1);
    }
    catch (error) {
        return num;
    }
};
export const parseNumber = (value) => {
    // example 1,000
    if (!value) {
        return `0`;
    }
    try {
        const formattedValue = value.toLocaleString('en-US', {
            maximumFractionDigits: 0
        });
        return formattedValue;
    }
    catch (error) {
        console.log(error);
        return `${value}`;
    }
};
